import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { POPUP_MINIMIZED_WIDTH_SIZE } from '@app/main/main-content/floating-popup-manager/configs/floating-popup.config';
import { ElementWidthClassDirective } from '@app/shared/directives/element-width-class-directive';
import { IFloatingPopupInstance } from '@app/main/main-content/floating-popup-manager/interfaces/floating-popup-instance';
import { FpLoggerNoisePicturesStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-pictures/services/fp-logger-noise-pictures/fp-logger-noise-pictures.store';
import { FloatingPopupBaseErrorMessageComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-base-error-message/floating-popup-base-error-message.component';
import { PictureGalleryListItemComponent } from '@app/core/picture-gallery/components/picture-gallery-list-item/picture-gallery-list-item.component';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'gc-fp-logger-noise-pictures-minimized',
  standalone: true,
  imports: [
    ElementWidthClassDirective,
    TranslateDirective,
    FloatingPopupBaseErrorMessageComponent,
    PictureGalleryListItemComponent,
  ],
  templateUrl: './fp-logger-noise-pictures-minimized.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'h-full',
  },
})
export class FpLoggerNoisePicturesMinimizedComponent {
  public readonly currentTabStore = inject(FpLoggerNoisePicturesStore);

  public popup = input<IFloatingPopupInstance>();

  public readonly POPUP_MINIMIZED_WIDTH_SIZE = POPUP_MINIMIZED_WIDTH_SIZE;

  private readonly popupMainData = toSignal(this.currentTabStore.popupMainData$, {
    initialValue: null,
  });

  public readonly data = toSignal(this.currentTabStore.data$, {
    initialValue: null,
  });

  public error = toSignal(this.currentTabStore.error$, {
    initialValue: null,
  });

  public isDataExist = computed(() => !!this.data()?.length);

  public readonly loggerDeployment = computed(() => this.popupMainData()?.deployment);
}
